import { createColumnHelper } from "@tanstack/react-table";

import { Patient } from "~/common/utils";
import {
  formatConsultationRequestRowData,
  formatDateToComplete,
  getFullName,
} from "~/providers/utils";
import { NotificationPoint } from "../icons";
import { PATIENTS_TABLE_COLUMN_IDS } from "./patientsTableSorting";

const columnHelper = createColumnHelper<Patient>();

export const patientsTableColumns = [
  columnHelper.accessor((row) => getFullName(row.name, row.last_name), {
    id: PATIENTS_TABLE_COLUMN_IDS.name,
    header: "Name",
    cell: ({ row }) => {
      const { name, last_name: lastName, organization_patients } = row.original;

      return (
        <div className="flex items-center gap-4 capitalize">
          <NotificationPoint
            className={
              !organization_patients[0].is_reviewed
                ? "text-red-500"
                : "text-neutral-200"
            }
          />
          {getFullName(name, lastName)}
        </div>
      );
    },
  }),
  columnHelper.accessor((row) => row.last_feed?.description ?? "-", {
    id: PATIENTS_TABLE_COLUMN_IDS.lastInteraction,
    header: "Last patient interaction",
    cell: ({ row }) => row.original.last_feed?.description ?? "-",
  }),
  columnHelper.accessor(
    (row) =>
      getFullName(
        row.organization_patients?.[0]?.primary_provider?.name,
        row.organization_patients?.[0]?.primary_provider?.last_name,
      ) || "-",
    {
      id: PATIENTS_TABLE_COLUMN_IDS.primaryProvider,
      header: "Primary provider",
      cell: ({ row }) => {
        const providerName = getFullName(
          row.original.organization_patients?.[0]?.primary_provider?.name,
          row.original.organization_patients?.[0]?.primary_provider?.last_name,
        );

        return (
          <span className="first-letter:uppercase">{providerName || "-"}</span>
        );
      },
    },
  ),
  columnHelper.accessor((row) => formatConsultationRequestRowData(row).state, {
    id: PATIENTS_TABLE_COLUMN_IDS.state,
    header: "State",
    cell: ({ row }) => formatConsultationRequestRowData(row.original).state,
  }),
  columnHelper.accessor(
    (row) =>
      row.last_feed ? formatDateToComplete(row.last_feed.created_at) : "-",
    {
      id: PATIENTS_TABLE_COLUMN_IDS.lastUpdated,
      header: "Last updated",
      cell: ({ row }) =>
        row.original.last_feed
          ? formatDateToComplete(row.original.last_feed.created_at)
          : "-",
    },
  ),
];
